'use strict'

angular.module('rmTrashcan', [])

require('./controller')
require('./routes')
